import { Box, Typography } from '@mui/material';
import LoaderIcon from 'src/components/LoaderImg/loader.gif';
import emptyImg from 'src/pages/therapist-dashboard/therapist-document/image-removebg-preview.png';
import React from 'react';

interface DocumentTableLoaderProps {
  allDocumentsOfPhysician: {
    loading: boolean;
    areGetDocuments: boolean;
    response: any;
  };
}

export const DocumentTableLoader: React.FC<DocumentTableLoaderProps> = ({
  allDocumentsOfPhysician,
}) => {
  if (allDocumentsOfPhysician?.loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 250,
          width: '100%',
        }}
      >
        <img
          src={LoaderIcon}
          alt="loader.."
        />
      </div>
    );
  }

  if (!allDocumentsOfPhysician?.areGetDocuments && allDocumentsOfPhysician?.response !== null) {
    return (
      <Box>
        <img
          src={emptyImg}
          alt="loader"
          style={{
            width: 720,
            height: 300,
            margin: 'auto',
            alignItems: 'center',
            alignContent: 'center',
            marginTop: 100,
            display: 'block',
          }}
        />
        <Typography
          color="text.secondary"
          variant="h5"
          fontWeight="200"
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          Something went wrong
        </Typography>
      </Box>
    );
  }

  return null;
};

export default DocumentTableLoader;
